import { useTenantPermission } from "../../../Core/hooks/usePermission";
import { TENANT_PERMISSIONS } from "../../Login/constants";

const useMapMarkerHeaders = () => {
  return [
    {
      id: 1,
      title: "Hub Stations",
      hasPermission: useTenantPermission([
        TENANT_PERMISSIONS.LOCATION_MODULE_ACCESS,
      ]),
    },
    {
      id: 4,
      title: "Farms",
      hasPermission: useTenantPermission([
        TENANT_PERMISSIONS.LOCATION_MODULE_ACCESS,
      ]),
    },
    {
      id: 5,
      title: "Trikes",
      hasPermission: useTenantPermission([
        TENANT_PERMISSIONS.TRIKE_MODULE_ACCESS,
      ]),
    },
  ];
};

export default useMapMarkerHeaders;
